import React, { useEffect, useState } from 'react';
import Map, { Marker } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import HappyHourApi from '../api/backendApi.js';
import { Link, useParams } from 'react-router-dom';
import '../spaces/Spaces.css';

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

const SpaceMap = () => {
  const { title } = useParams();
  const [location, setLocation] = useState(null);
  const [space, setSpace] = useState(null);

  useEffect(() => {
    const fetchSpaceDetails = async () => {
      try {
        const spaceDetails = await HappyHourApi.request(`spaces/${title}`);
        setSpace(spaceDetails.space);

        const address = spaceDetails.space.address;
        const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json?access_token=${MAPBOX_TOKEN}`;
        const res = await fetch(url);
        const data = await res.json();

        if (data.features && data.features.length > 0) {
          const [lng, lat] = data.features[0].center;
          setLocation({ lat, lng });
        } else {
          console.error('No results found for the given address.');
        }
      } catch (error) {
        console.error('Error while fetching space details:', error);
      }
    };

    fetchSpaceDetails();
  }, [title]);

  return (
    <div className="Space-Detail-Container">
      <Link style={{ textDecoration: 'none' }} to={`/spaces/${title}`}>
        <h2 className="Space-Title">{title}</h2>
      </Link>
      {space && (
        <div style={{ marginBottom: '16px' }}>
          <p style={{ color: 'var(--color-text-light)', fontSize: '14px' }}>{space.description}</p>
          <p style={{ fontSize: '14px' }}><strong>Address:</strong> {space.address}</p>
        </div>
      )}
      {location && (
        <Map
          initialViewState={{ longitude: location.lng, latitude: location.lat, zoom: 15 }}
          style={{ width: '100%', height: '60vh', borderRadius: 'var(--radius-md)' }}
          mapStyle="mapbox://styles/mapbox/light-v11"
          mapboxAccessToken={MAPBOX_TOKEN}
        >
          <Marker longitude={location.lng} latitude={location.lat} color="#e07b6e" />
        </Map>
      )}
    </div>
  );
};

export default SpaceMap;
